import React from "react";
import "./portfolio2.css";
import worker1 from "../images/servicer1.jpg";
import worker2 from "../images/Servicer2.jpg";
import worker3 from "../images/Servicer3.jpg";
import worker4 from "../images/Servicer4.jpg";
import worker5 from "../images/Servicer5.jpg";
import worker6 from "../images/Servicer6.jpg";
import { Link } from "react-router-dom";

const works = [
  { id: 1, title: "Hours Cleaning", category: "Cleaning Services", image: worker1 },
  { id: 2, title: "Office Cleaning", category: "Cleaning Services", image: worker2 },
  { id: 3, title: "Home Cleaning", category: "Cleaning Services", image: worker3 },
  { id: 4, title: "Window Cleaning", category: "Cleaning Services", image: worker4 },
  { id: 5, title: "Kitchen Cleaning", category: "Cleaning Services", image: worker5 },
  { id: 6, title: "Freeze Cleaning", category: "Cleaning Services", image: worker6 },
];

const Portfolio2 = () => {
  return (
    <div className="portfolio-section">
      <div className="portfolio-grid">
        {works.map((work) => (
          <Link 
            to="/portfolio-details" 
            key={work.id} 
            className="portfolio-card-link"
          >
            <div className="portfolio-card">
              <img src={work.image} alt={work.title} className="portfolio-image" />
              <div className="overlay">
                <div className="overlay-content">
                  <div className="icon">+</div>
                  <h3>{work.title}</h3>
                  <p>{work.category}</p>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>

      <p className="learn-more-text">
        Want to learn more about Our Latest Work? <a href="/portfolio-details">Click here</a>
      </p>
    </div>
  );
};

export default Portfolio2;
